import { render, staticRenderFns } from "./Bio.vue?vue&type=template&id=a75b0404&scoped=true"
import script from "./Bio.vue?vue&type=script&lang=js"
export * from "./Bio.vue?vue&type=script&lang=js"
import style0 from "./Bio.vue?vue&type=style&index=0&id=a75b0404&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a75b0404",
  null
  
)

export default component.exports